<script>
import { mapGetters } from "vuex";

import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import Detail from "./Detail.vue";

export default {
  page: {
    title: "Hỗ Trợ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Detail },
  data() {
    return {
      title: "Hỗ Trợ",
      items: [
        {
          text: "Hệ Thống",
          href: "/",
        },
        {
          text: "Hỗ Trợ",
          active: true,
        },
      ],
      subject: {
        content: "",
        subject: null,
      },
      fields: [
        {
          key: "ticket_ID",
          sortable: false,
          label: "Mã",
          class: "text-center text-middle",
        },
        {
          key: "ticket_subject_name",
          sortable: false,
          label: "Vấn Đề",
          class: "text-center text-middle",
        },
        {
          key: "ticket_Status",
          sortable: false,
          label: "Trạng Thái",
          class: "text-center text-middle",
        },
        {
          key: "ticket_Time",
          sortable: false,
          label: "Thời Gian",
          class: "text-center text-middle",
        },
        {
          key: "ticket_User",
          sortable: false,
          label: "Thao Tác",
          class: "text-center text-middle",
        },
      ],
      showTicket: {
        id: null,
        subject: null,
        show: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      Subject: "support/Subject",
      List: "support/List",
    }),
  },
  methods: {
    async onSendSubject() {
      const token = await this.generateCaptChaV3("create_account");
      if (!token) {
        this.$toastr.e("Quá nha vui lòng thử lại sau vài giây.");
      }
      this.subject.token = token;
      this.$store.dispatch("support/req_postSubject", this.subject);
    },
    ResetDetail() {
      this.showTicket = {
        id: null,
        subject: null,
        show: false,
      };
      this.$store.state.support.detail = [];
    },
    onShowDetail(info) {
      const { item } = info;
      this.showTicket = {
        id: item.ticket_ID,
        subject: item.ticket_subject_id,
        show: true,
      };
    },
  },
  created() {
    this.$store.dispatch("support/req_SetUpTick");
    this.unsubscribe = this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case "support/POST_SUBJECT_SUCCESS":
          this.subject = {
            content: "",
            subject: null,
          };
          break;

        default:
          break;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container class="page-support">
      <b-row>
        <b-col xl="5" lg="6" md="12" class="p-0">
          <div class="box-write" v-if="!showTicket.show">
            <div class="title">Tạo Biểu Mẫu</div>
            <b-form @submit.prevent="onSendSubject">
              <div class="form-group">
                <label for="Subject">Vấn Đề</label>
                <b-form-select
                  v-model.trim="subject.subject"
                  required
                  id="Subject"
                  class="text-capitalize"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      Vui lòng chọn vấn đề gặp phải
                    </b-form-select-option>
                  </template>
                  <b-form-select-option
                    v-for="subject in Subject"
                    :key="
                      `${subject.ticket_subject_id}${subject.ticket_subject_name}`
                    "
                    :value="subject.ticket_subject_id"
                  >
                    {{ subject.ticket_subject_name.replace("_", " ") }}
                  </b-form-select-option>
                </b-form-select>
              </div>
              <div class="form-group">
                <label for="des-subject">Chú Thích</label>
                <b-form-textarea
                  id="des-subject"
                  v-model="subject.content"
                  placeholder="Nhập chi tiết vấn đề khoảng 150 ký tự."
                  rows="3"
                  max-rows="6"
                  maxlength="150"
                ></b-form-textarea>
              </div>
              <div class="form-group">
                <b-button
                  variant="info"
                  type="submit"
                  class="d-flex align-items-center justify-content-center"
                >
                  Gửi <i class="fas fa-sign-in-alt ms-2"></i>
                </b-button>
              </div>
            </b-form>
          </div>
          <div class="box-detail" v-else>
            <Detail
              :ID="showTicket.id"
              :Subject="showTicket.subject"
              @close-detail="ResetDetail()"
            />
          </div>
        </b-col>
        <b-col xl="7" lg="6" md="12">
          <div class="box-table">
            <div class="title">Danh sách biểu mẫu</div>
            <div class="box-reponsive">
              <b-table striped hover :items="List" :fields="fields">
                <template #cell(ticket_Status)="data">
                  <b-button
                    :variant="
                      data.item.ticket_Status == 'Waiting'
                        ? 'warning'
                        : 'success'
                    "
                    class="btn-sm font-weight-bold"
                  >
                    {{
                      data.item.ticket_Status == "Waiting"
                        ? "Chờ phản hồi"
                        : "Đã phản hồi"
                    }}
                  </b-button>
                </template>
                <template #cell(ticket_User)="data">
                  <b-button
                    variant="info"
                    class="btn-sm font-weight-bold"
                    @click="onShowDetail(data)"
                  >
                    Chi Tiết
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Layout>
</template>
<style lang="scss">
.page-support {
  .form-control {
    background-color: #fff;
    color: #000;
    &::placeholder {
      color: rgba(0, 0, 0, 0.7);
    }
  }
  //   max-width: 1440px;
  margin: auto;
  .box-write,
  .box-table {
    box-shadow: 0 0.75rem 1.5rem rgb(0, 0, 0, 0.48);
    background: linear-gradient(to bottom, #008cff, #003395);
    border: 2px solid #00389b;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    border-radius: 10px;
    padding: 5px 0;
    margin-bottom: 15px;
    margin: 0 auto 15px;
    position: relative;
    width: calc(100% - 20px);
    min-height: 250px;
    .title {
      font-weight: 600;
      font-size: 20px;
      color: #fff;
      text-align: center;
      padding: 0 0 5px;
      border-bottom: 3px solid rgba($color: #000000, $alpha: 0.2);
      text-transform: uppercase;
      width: 100%;
    }
    form {
      width: 100%;
      padding: 10px 20px;
      .form-group {
        width: 100%;
        margin-bottom: 20px;
        label {
          font-weight: 600;
          color: #ffff;
          font-size: 16px;
          margin-bottom: 0px;
          width: 100%;
          margin-bottom: 5px;
        }
        select,
        input {
          width: 100%;
          border: 0;
          border-radius: 0;
          border-bottom: 2px solid #6c757d;
          height: 40px;
          font-size: clamp(10px, 1vw, 13.2px);
          font-weight: 600;
          background: #fff;
          border-radius: 5px;
          color: #000;
          padding-left: 5px;
          &:focus {
            box-shadow: none;
            border-bottom: 2px solid #097501;
          }
          &::placeholder {
            font-weight: 500;
            font-size: clamp(13px, 1vw, 15px);
          }
        }
        button {
          border: 0;
          box-shadow: 0 0.75rem 1.5rem rgb(0, 0, 0, 0.48);
          font-size: 1.2em;
          font-weight: 600;
          letter-spacing: 0.05rem;
          position: relative;
          color: #fff !important;
          min-width: 130px;
          width: 100%;
          height: 45px;
          overflow: hidden;
          transition: 0.3s ease-in-out;
          border-radius: 0.3rem;
          z-index: 1;
          &:hover,
          &:focus,
          &:focus-visible {
            box-shadow: 0 5px 18px rgba(0, 0, 0, 0.2),
              0 10px 12px rgba(0, 0, 0, 0.2);
          }
        }
      }
    }
  }
  .box-detail {
    box-shadow: 0 0.75rem 1.5rem rgb(0, 0, 0, 0.48);
    background: linear-gradient(to bottom, #008cff, #003395);
    border: 2px solid #00389b;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    border-radius: 10px;
    margin: 0 auto 15px;
    position: relative;
    width: calc(100% - 20px);
    min-height: 250px;
  }
  .box-table {
    width: 100%;
    .box-reponsive {
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      table {
        width: 100%;
        .table th,
        .table td {
          min-width: 100px;
          white-space: pre;
        }
      }
    }
  }
}
</style>
